
let tEl = (document.getElementsByTagName("title")[0]) as HTMLTitleElement;

export function setTitle(title:string){
	tEl.innerText = `WF - ${title}`;
}

export function resetTitle(){
	tEl.innerText = "WF Admin";
}